import React, { FunctionComponent, memo } from 'react';
import { Box } from '@material-ui/core';
import IExtendedFeaturesList from '../../../../../../../model/IExtendedFeaturesList';
import summaryStyles from '../../../../summary/summarySection/SummaryStyles';
import FeatureCategoryTitle from '../../../../featureCategories/featureCategoryTitle/FeatureCategoryTitle';
import SelectedFeatureOption from './selectedFeatureOption/SelectedFeatureOption';
import CategoryPurpose from '../../../../../../../enum/CategoryPurpose';

export interface ISelectedFeaturesListProps {
  featuresList: IExtendedFeaturesList;
  sectionName?: string;
  sectionCode: string;
  sectionType?: string;
  sectionDisclaimerIndicative?: string;
  categoryPurpose?: CategoryPurpose;
}

const SelectedFeaturesList: FunctionComponent<ISelectedFeaturesListProps> = memo(
  ({ featuresList, sectionName, sectionCode, sectionType, sectionDisclaimerIndicative, categoryPurpose }) => {
    const styles = summaryStyles();

    return (
      <Box className={styles.selectionContainer} data-test={`summary_expanded:section:${sectionCode}`}>
        <FeatureCategoryTitle
          name={sectionName}
          code={sectionCode}
          classes={{ title: styles.selectedFeaturesCategoryTitle, indicativeNumber: styles.indicativeNumber }}
          isSummary={true}
          disclaimerIndicative={sectionDisclaimerIndicative}
        />
        <SelectedFeatureOption
          featuresList={featuresList}
          sectionCode={sectionCode}
          sectionType={sectionType}
          categoryPurpose={categoryPurpose}
        />
      </Box>
    );
  },
);

export default SelectedFeaturesList;
